module.exports = __webpack_public_path__ + "static/media/sum_plan_in_month.bb6fd984.png";